import { render, staticRenderFns } from "./PropostaVisualizar.vue?vue&type=template&id=e6d60fde"
import script from "./PropostaVisualizar.vue?vue&type=script&lang=js"
export * from "./PropostaVisualizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports